import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSparkle2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSparkle2"><Path d="M12 2.75C13.9474 8.10526 15.8947 10.0526 21.25 12C15.8947 13.9474 13.9474 15.8947 12 21.25C10.0526 15.8947 8.10526 13.9474 2.75 12C8.10526 10.0526 10.0526 8.10526 12 2.75Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSparkle2;
